export const PersonnelEN = {
    "contractType":"Contract Type",
    "rewardWelfare":"Reward Welfare",
    "jobPosition":"Job Position",
    "jobTitle":"Job Title",
    "workLocation":"WorkLocation",
    "companyRules":"Company Rules",
    "allowancesType":"Allowances Type",
    "levelAndPayGrade":"Level And Pay Grade",
    "category":"Category",
    "employeeType":"Employee Type",
}